/**
 * Widest a logo half — heading, upload box and specifications — is allowed to
 * get. Without it the text keeps growing with the column on a wide screen
 * while the preview box stays put, so the description runs past the box it
 * describes. Applied to the half itself rather than to the grid column,
 * because `auto-fit` counts how many columns fit by their maximum: a definite
 * maximum here would drop the layout to a single column around 1100px.
 *
 * It lives here rather than in createAppTheme.js because that file is the brand
 * palette and shape, shared by every screen; this width belongs to one section
 * of one tab, and is read by LogoHalf and by the row that lays the two out.
 */
export const LOGO_HALF_MAX_WIDTH = '600px';
